<script>
export default {
  name: 'UlCol',
  props: {
    span: {
      default: 12,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`ul-col--${this.span}`]: true,
        'ul-col--shadow': this.shadow,
      };
    },
  },
};
</script>
<template>
  <div class="ul-col" :class="classes">
    <slot></slot>
  </div>
</template>
<style lang="scss">
  @for $i from 0 through 12 {
    .ul-col--#{$i} {
      $width: ($i/12)*100%;
      width: $width;
    }
  }

  .ul-col {
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    padding: 0 12px;

    &--shadow {
      padding: 8px 24px;
      margin: 0 12px;
      background: #ffffff;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }
</style>
